(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-stories"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
  const carousel = document.querySelector('.category-carousel');
  const track = document.querySelector('.category-track');
  const items = track.children;
  const itemCount = items.length / 2; // Half are duplicates

  carousel.addEventListener('scroll', function() {
  const scrollLeft = carousel.scrollLeft;
  const maxScroll = track.scrollWidth - carousel.clientWidth;
  const itemWidth = items[0].offsetWidth + 16; // width + gap

  // If scrolled to end, jump to beginning
  if (scrollLeft >= maxScroll - 10) {
  carousel.scrollLeft = scrollLeft - (itemCount * itemWidth);
  }
  // If scrolled to beginning, jump to end
  else if (scrollLeft <= 10) { carousel.scrollLeft=scrollLeft + (itemCount * itemWidth); } }); }); 
  } catch(e) { console.error(e); }
})();
})();
